/**
 * Not all ILS filter types have "operators", so just grab the ones that do
 */
const getOperatorForILSFilter = filter => {
  switch (filter.filterType) {
    case 'PROPERTY':
      return filter.operation.operator;
    case 'ASSOCIATION':
    case 'IN_LIST':
    case 'PAGE_VIEW':
    case 'EVENT':
    case 'ADS_SEARCH':
    case 'CTA':
    case 'WEBINAR':
    case 'SURVEY_MONKEY':
    case 'SURVEY_MONKEY_VALUE':
      return filter.operator;
    case 'EMAIL_SUBSCRIPTION':
      // There should only ever be one element in this array for filters
      return filter.acceptedStatuses[0];
    default:
      return undefined;
  }
};
export const getTrackingDataFromReenrollmentFilters = filtersList => {
  const trackingData = {
    properties: [],
    operators: []
  };
  filtersList.forEach(filter => {
    const property = filter.property;
    const operator = filter.operation && filter.operation.operator;
    if (property && operator) {
      trackingData.properties.push(property);
      trackingData.operators.push(operator);
    }
  });
  return trackingData;
};
export const populateTrackingDataFromILSFilters = (filterBranch, associatedObject, properties = [], operators = [], associatedObjects = [], filterTypes = []) => {
  filterBranch.filterBranches.forEach(subFilterBranch => {
    populateTrackingDataFromILSFilters(subFilterBranch,
    // Set the associatedObject type for every sub-filter of an association filter branch, if it exists
    subFilterBranch.objectTypeId, properties, operators, associatedObjects, filterTypes);
  });
  filterBranch.filters.forEach(filter => {
    // If we're dealing with a property filter, use that property. Otherwise the `property` field will be undefined
    properties.push(filter.property);
    operators.push(getOperatorForILSFilter(filter));
    associatedObjects.push(associatedObject);
    filterTypes.push(filter.filterType);
  });
};
export const getEnrollmentTrackingDataFromCombinedEnrollment = (triggers, reenrollmentState) => {
  const properties = [];
  const operators = [];
  const associatedObjects = [];
  const filterTypes = [];
  if (triggers) {
    populateTrackingDataFromILSFilters(triggers, undefined, properties, operators, associatedObjects, filterTypes);
  }
  const reenrollmentProperties = [];
  const reenrollmentOperators = [];
  reenrollmentState.filter(({
    checked
  }) => checked).forEach(({
    filterBranch
  }) => {
    populateTrackingDataFromILSFilters(filterBranch, undefined, reenrollmentProperties, reenrollmentOperators, [], []);
  });
  const filterBranchLength = triggers ? triggers.filterBranches.length : 0;
  return {
    properties,
    operators,
    filterType: filterTypes,
    // NOTE: Necessary that this is `associatedObjectTypeIds` since we hit our Amplitude property limit
    associatedObjectTypeIds: associatedObjects,
    reenrollmentProperties,
    reenrollmentOperators,
    length: filterBranchLength
  };
};
const getEventEnrollmentCriteriaTrackingData = triggers => {
  const properties = [];
  const operators = [];
  const eventTypeIds = [];
  let filterBranchLength = 0;
  if (triggers) {
    filterBranchLength = triggers.filterBranches.length;
    triggers.filterBranches.forEach(filterBranch => {
      if (!filterBranch.filterBranches.length) {
        // list membership special case
        eventTypeIds.push('LIST_MEMBERSHIP');
        populateTrackingDataFromILSFilters(filterBranch, undefined, properties, operators);
      } else {
        const eventFilterBranch = filterBranch.filterBranches[0];
        eventTypeIds.push(eventFilterBranch.eventTypeId);

        // tracks inner property filters, if they exist
        populateTrackingDataFromILSFilters(eventFilterBranch, undefined, properties, operators);
      }
    });
  }
  return {
    properties,
    operators,
    eventTypeIds,
    length: filterBranchLength
  };
};
export const getEventTrackingDataWithTriggers = ({
  triggers,
  refinementCriteria
}) => {
  const refinementProperties = [];
  const refinementOperators = [];
  const filterTypes = [];
  const {
    properties: eventFilterProperties,
    operators: eventFilterOperators,
    eventTypeIds
  } = getEventEnrollmentCriteriaTrackingData(triggers);
  if (refinementCriteria) {
    populateTrackingDataFromILSFilters(refinementCriteria, undefined, refinementProperties, refinementOperators, undefined, filterTypes);
  }
  return {
    properties: [...eventFilterProperties, ...refinementProperties],
    operators: [...eventFilterOperators, ...refinementOperators],
    filterType: filterTypes,
    eventType: eventTypeIds
  };
};